import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import {
  createStateSyncMiddleware,
  initStateWithPrevTab
} from "redux-state-sync";

import { ACCOUNT, CORE } from "../actions/actionConstants.js";
import { AUTHENTICATION } from "../reducers/authentication/authenticationConstants.js";

import reducers from "../reducers/index.js";

export function configureAppStore(preloadedState) {
  // -- SETUP MIDDLEWARE -- //

  const stateSyncConfig = {
    // only these actions will be broadcast across tabs
    // we are just trying to keep core state in sync
    // each tab should self manage depending on location
    whitelist: [
      AUTHENTICATION.LOGOUT.DO,
      AUTHENTICATION.LOGOUT.POST_COMPLETE,
      AUTHENTICATION.LAST_ACTIVITY,
      AUTHENTICATION.INACTIVITY_WARNING.RESET,
      ACCOUNT.RECEIVE,
      CORE.FULL_REFRESH,
      CORE.PART_REFRESH
    ]
  };

  const stateSyncMiddleware = createStateSyncMiddleware(stateSyncConfig);
  const sagaMiddleware = createSagaMiddleware();

  // -- SETUP STORE -- //

  const store = configureStore({
    reducer: reducers,
    middleware: [sagaMiddleware, stateSyncMiddleware],
    preloadedState
  });

  // -- STARTUP MIDDELWARE -- //

  store.runSaga = sagaMiddleware.run;
  initStateWithPrevTab(store);

  return store;
}

const store = configureAppStore({});

export default store;
